import React from "react";

/**
 * ErrorBoundary — catches unhandled render errors in child components
 * and shows an informative message instead of a completely blank page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught a render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
          fontFamily: "ABBvoice, Arial, sans-serif",
          color: "#333"
        }}>
          <h2 style={{ color: "#c00" }}>Something went wrong</h2>
          <p style={{ maxWidth: 500, textAlign: "center" }}>
            {this.state.error?.message || "An unexpected error occurred while loading this page."}
          </p>
          <button
            style={{
              marginTop: 16,
              padding: "8px 20px",
              background: "#1f1f1f",
              color: "#fff",
              border: "none",
              borderRadius: 20,
              cursor: "pointer",
              fontSize: 14
            }}
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
